import { StepsActions } from "../../reducers/steps/actionsNames";
import { IStepAnswers } from "../../reducers/steps";

export default function (answer: IStepAnswers) {
  return {
    type: StepsActions.SetAnswer,
    answer,
  };
}
